import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 30%;
  margin-left: 2%;
  min-height: 150px;
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  height: max-content;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`;

export const ServicePeriodList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ServicePeriodListItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border-radius: 5px;
  margin-bottom: 10px;
  border: ${({ isSelected }) =>
    isSelected
      ? '1px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
`;

export const Title = styled.div`
  margin-bottom: 5px;
  font-weight: 450;
`;

export const PriceDetails = styled.div`
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #53505069;
  text-align: right;
  margin-bottom: 15px;
  font-weight: 500;
  font-size: 1.2rem;
`;

export const ServicePlanList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ServicePlanListItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ServicePlanListItem = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border: ${({ isSelected }) =>
    isSelected
      ? '1px solid rgba(32, 154, 214, 1)'
      : '1px solid rgba(0, 0, 0, 0.23)'};
  border-radius: 5px;
  margin-right: 10px;
`;

export const QuoteButtonContainer = styled.div`
  margin-top: 5%;
`;

export const FormElementWrapper = styled.div`
  margin: 20px 0px;
`;
